import { SavedAddressesModal } from '../ui';
import { useModalStore } from '@/shared/lib';

type Params = {
  onBack: () => void;
};

export function useSavedAddressesModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openSavedAddressesModal = ({ onBack }: Params) => {
    showDialogComponent({
      component: <SavedAddressesModal onBack={onBack} />,
      className:
        'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto bg-secondary-bg border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openSavedAddressesModal };
}
